import { z } from "zod";

import { COUNTRIES } from "@/constants/countries";
import { emailField } from "@/validation/primitives";
import { tKey } from "@/validation/messages";

// Looser than validation/primitives.ts::usernameField because existing users
// created via `normalizeUsernameBase` (utils/username.web.ts) may have `.`
// in their username. This field is for lookup, not creation.
export const usernameLookupField = z
  .string()
  .trim()
  .min(1, tKey("PLEASE_ENTER_USERNAME"))
  .min(3, tKey("USERNAME_TOO_SHORT"))
  .regex(/^@?[a-zA-Z0-9_.]+$/, tKey("USERNAME_INVALID_CHARACTERS"));

const validPhonePrefixes = COUNTRIES.map((c) =>
  "phonePrefix" in c ? (c.phonePrefix as string | undefined) : undefined,
).filter((p): p is string => Boolean(p));

export const invitePhoneField = z.object({
  prefix: z
    .string()
    .min(1, tKey("PLEASE_SELECT_COUNTRY"))
    .refine(
      (v) => validPhonePrefixes.includes(v),
      tKey("PLEASE_SELECT_COUNTRY"),
    ),
  number: z.string().trim().min(1, tKey("PLEASE_ENTER_PHONE")),
});

export const inviteSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("email"), email: emailField }),
  z.object({ type: z.literal("username"), username: usernameLookupField }),
  z.object({ type: z.literal("phone"), phone: invitePhoneField }),
]);

export type InviteFormValues = z.infer<typeof inviteSchema>;
